import React from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";


import { MainHeadingWrapper } from "../../Elements/Elements";
import ProjectCard from "./ProjectCard";
import ProjectDetail from "./ProjectDetail";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "scroll",
    padding: "100px 0 ",
  },
}));

const BridgeTwo = styled.div`
  padding-top: 150px;
  width: 100%;
  margin: 0 auto;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.fontColor};

  /* min-height: 400px; */
  z-index: 99;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  > div:nth-child(2) {
    padding: 50px 0;
    border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    grid-row-gap: 20px;
    width: 90%;
    margin: 30px auto;
    align-items: center;
    justify-content: space-evenly;
    background-size: cover;
    background-position: center;
  }
`;

let projectArray = [
  {
    img : "https://i.postimg.cc/tRhH89PK/Screenshot-163.png",
    description: "Bath & Body Works - Ecommerce for beauty & health care",
    techStack: [
      "HTML",
      "CSS",
      "JavaScript",
      "github",
      ],
    repoLink: "https://github.com/abhaskar007/Bath-Bodyworks",
    demoLink: "https://sathish-dhana.github.io/Bath-Bodyworks/ProjectFiles/sign_in.html",
    type: "A collaborative project built by a team of 5 executed in 4 days.",
    blogLink: "https://medium.com/@abhishek94.bhaskar/masai-unit-2-construct-week-project-9f67c00265f4",
    features: [
      "Signup and Login.",
      "A user can add a product to cart or to wishlist.",
      "A user can sort and filter.",
      "A user can order by filling in the required details",
      "Orders history can be viewer in profile page",
    ],
    responsibilities: [
      "Built the shipping & address page",
      "All the data got store in local storage",
      "Built Review and Feedback page",
    ],
  },
  {
    img: "https://i.postimg.cc/44DzSjqM/Screenshot-164.png",
    title: "CB2",
    description: "CB2 frontend- online Ecommerce for Home decor and furniture",
    techStack: [
      "HTML",
      "CSS",
      "JavaScript",
      "github",
    ],
    // responsibilities: [
    //   "Developed the API for product page",
    //   "Built the product page",
    //   "Built the Cart page",
    //   "Built Review and Feedback page",
    // ],
    repoLink: "https://github.com/Santhosh-1997/CB2.com-clone",
    demoLink: "https://cb2clone.netlify.app/",
    type: "A collaborative project built by a team of 4 under 4 days",
    blogLink: "https://medium.com/@99santhoshs/second-project-at-masai-99fec237f39d",
    features: [
      "Signup and Login.",
      "Users can see the various home decor items and furniture products",
      "Allows users shortlist the selected items in cart and increase or decrease the quantity of products",
      "User can provide their feedback",
    ],
    responsibilities: [
      "Developed the API for product page",
      "Built the product page",
      "Built the Cart page",
      "Built Review and Feedback page",
    ],
  },
  {
    img: "https://i.postimg.cc/MHtLKxCW/Screenshot-165.png",
    title: "Cb2- Full Stack ",
    description:
      "Cb2 - Full stack online Ecommerce for Home decor and furniture",

    techStack: [
      "HTML",
      "CSS",
      "JavaScript",
      "Node",
      "Express",
      "MongoDB",
    ],
    repoLink: "https://github.com/somi-kumari/cb2.com-clone_U4",
    demoLink: "https://github.com/somi-kumari/cb2.com-clone_U4",
    type: "A collaborative project built by a team of 3 executed in 4 days.",
    blogLink: 
      "https://somi.hashnode.dev/how-we-cloned-cb2",
    features: [
      "Login and Signup",
      "A user Authentication Google  credentials",
      "Exporting images and data from backend",
      "Users can see the various home decor items and furniture products",
      "Allows users shortlist the selected items in cart and increase or decrease the quantity of products",
    ],
    responsibilities: [
      "Create data for home page and store and Backend",
      "Created the cart page ",
      "Created Review and feedback page",
      "Created success page and Otp page",
    ],
  },

  // {
  //   img: "https://user-images.githubusercontent.com/39058941/115154017-68e04980-a096-11eb-8c0c-820652ed499e.png",
  //   title: "Sudoku",
  //   description:
  //     "A sudoku challenge for users, where they can solve or submit their own puzzles and get them solved.",
  //   techStack: ["HTML", "CSS", "JavaScript"],
  //   repoLink: "https://github.com/therealdrtroll/sudoku",
  //   demoLink: "https://sudoku-solver-animated.netlify.app/",
  //   type: "Solo project",
  //   blogLink: "#",
  //   features: [
  //     "User can solve a puzzle",
  //     "User can submit a puzzle and solve",
  //     "User can get solution for a puzzle using auto-solve",
  //   ],
  // },
  // {
  //   img: "https://user-images.githubusercontent.com/39058941/118371705-7d4b2f80-b5cb-11eb-9cfd-a5a917f759e0.png",
  //   title: "Product Hunt ",
  //   description:
  //     "An online product portal where users can browse, research, and post products. ",
  //   techStack: ["HTML", "CSS", "JavaScript", "React", "MaterialUI"],
  //   repoLink: "https://github.com/therealdrtroll/product-hunt",
  //   type: "A collaborative project built by a team of 4 under 4 days.",
  //   demoLink: "https://producthuntalpha.netlify.app/",
  //   blogLink:
  //     "https://ar1pperk.medium.com/how-can-you-collab-remotely-to-develop-an-effective-product-in-4-days-ff3d2a0168dd",
  //   features: [
  //     "Research products and post products.",
  //     "Research jobs and post jobs.",
  //     "Raise a discussion and comment under it.",
  //     "Book an appointment with your favourite product mentor.",
  //   ],

  //   responsibilities: [
  //     "Scraped data from the original product hunt.",
  //     "Developed pixel-perfect UI of the product page.",
  //     "Implemented features like up-vote, share, and single product modal.",
  //   ],
  // },
];

function Projects() {
  const [panel, setPanel] = React.useState(false);
  let [currentProject, setCurrentProject] = React.useState({});
  const classes = useStyles();
  return (
    <div id="projects">
      <BridgeTwo backgroundImg={currentProject.img}>
        <MainHeadingWrapper>
          <h1>Projects</h1>
          <div></div>
        </MainHeadingWrapper>
        <div>
          {projectArray?.map((project) => (
            <ProjectCard
              key={project.title}
              setCurrentProject={setCurrentProject}
              setPanel={setPanel}
              {...project}
            ></ProjectCard>
          ))}
        </div>
        <Modal
          className={classes.root}
          open={panel}
          onClose={() => setPanel(false)}
        >
          <ProjectDetail
            {...currentProject}
            setPanel={setPanel}
          ></ProjectDetail>
        </Modal>
      </BridgeTwo>
    </div>
  );
}

export default Projects;
